import { render } from "./LandingHome.vue?vue&type=template&id=b11cb4b4&scoped=true"
import script from "./LandingHome.vue?vue&type=script&lang=js"
export * from "./LandingHome.vue?vue&type=script&lang=js"

import "./LandingHome.vue?vue&type=style&index=0&id=b11cb4b4&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b11cb4b4"]])

export default __exports__